import Accordion from "@mui/material/Accordion";

const VoyageAccordion = ({
  accordionId,
  expandedId,
  setExpandedId,
  slotProps,
  ...props
}) => {
  const isControlled =
    accordionId !== undefined &&
    expandedId !== undefined &&
    setExpandedId !== undefined;

  return (
    <Accordion
      expanded={isControlled ? expandedId === accordionId : undefined}
      onChange={
        isControlled
          ? (_, isExpanded) =>
              setExpandedId(isExpanded ? accordionId : null)
          : undefined
      }
      slotProps={{
        ...slotProps,
      }}
      {...props}
    />
  );
};

export default VoyageAccordion;